import React, { useState } from 'react';
import { setOrgId } from '../../../redux/slices/orgSlice';
import { setToken } from '../../../redux/slices/authSlice';
import { setUserData } from '../../../redux/slices/userDataSlics';
import { useNavigate, storeData, useDispatch, useSelector } from '../../../common/CommonExport';
import { Dropdown, Menu, Space } from 'antd';
import { clearEventData } from '../../../redux/slices/empEventsSlice';
import { toggleEmployeeTable } from '../../../redux/employeetable/employeeTableAction';
import keycloak from '../../../hooks/keycloak';

export default function ProfilePicture() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const imageBaseUrl = process.env.REACT_APP_IMAGE_VIEW;
    const userData = useSelector((state: any) => state?.loginUserData?.userData.data);
    const employeeDetails = useSelector((state: any) => state?.employee?.employeeDetails);
    const employeePermission = useSelector((state: any) => state?.employeePermissionSlice?.employeePermission)
    const [isDropdownVisible, setDropdownVisible] = useState(false);
    const [isProfileClicked, setIsProfileClicked] = useState(false);

    const toggleDropdown = () => {
        setDropdownVisible(!isDropdownVisible);
    };
    const handleLogout = () => {
        storeData('authToken', '', true);
        storeData('isLoggedIn', false, true);
        dispatch(setOrgId(''));
        dispatch(setToken(''));
        dispatch(setUserData(''));
        dispatch(clearEventData());
        dispatch(toggleEmployeeTable(false));
        keycloak.logout();
    };

    const handleProfile = () => {
        navigate('/user-dashboard/user-details');
    }
    const getInitials = (fullName?: string): string => {
        if (!fullName || typeof fullName !== 'string') return '';

        const words = fullName.trim().split(' ');
        if (words.length >= 2) {
            const firstNameInitial = words[0][0].toUpperCase();
            const lastNameInitial = words[words.length - 1][0].toUpperCase();
            return `${firstNameInitial}${lastNameInitial}`;
        } else if (words.length === 1) {
            return words[0][0].toUpperCase();
        } else {
            return '';
        }
    };


    const handleDropdownVisibleChange = (visible: any) => {
        setDropdownVisible(visible);
    };

    const menu = (
        <Menu onClick={(e) => e.domEvent.stopPropagation()} className={`logout-dropdown rounded-none bg-white ${isDropdownVisible ? 'visible' : ''}`}>
            {employeePermission && (
                <Menu.Item key="profile" onClick={handleProfile} className='font-rubik logout-icon text-sm border-b border-[#ccc] rounded-none '>
                    <span className='material-symbols-outlined mt-2'>person</span>
                    <span className='align-super mt-2 ml-2'>Profile</span>
                </Menu.Item>
            )}
            <Menu.Item key="logout" onClick={handleLogout} className='font-rubik logout-icon text-sm '>
                <span className='material-symbols-outlined mt-2'>logout</span>
                <span className='align-super mt-2 ml-2'>Logout</span>
            </Menu.Item>
        </Menu>
    );
    return (
        <div className='relative inline-block cursor-pointer'>

            <div className='profilePicture' onClick={toggleDropdown}>
                <Dropdown
                    trigger={['click']}
                    onOpenChange={handleDropdownVisibleChange}
                    open={isDropdownVisible}
                    overlay={menu}
                >
                    <a onClick={(e) => e.preventDefault()}>
                        <Space>
                            {employeePermission ? (
                                employeeDetails?.profileUrl ? (
                                    <img
                                        alt="logo"
                                        src={`${imageBaseUrl}${employeeDetails.profileUrl}`}
                                        className="w-[40px] h-[40px] rounded-full flex justify-center items-center"
                                    />
                                ) : (
                                    <p className="flex justify-center items-center text-white rounded-full text-base">
                                        {getInitials(`${employeeDetails.firstName} ${employeeDetails.lastName}`)}
                                    </p>
                                )
                            ) :
                                userData?.profile ? (
                                    <img
                                        alt="logo"
                                        src={`${imageBaseUrl}${userData.profile}`}
                                        className="w-[40px] h-[40px] rounded-full flex justify-center items-center"
                                    />
                                ) :
                                    (
                                        <p className="flex justify-center items-center text-white rounded-full text-base">
                                            {getInitials(userData?.name)}
                                        </p>
                                    )}
                        </Space>

                    </a>
                </Dropdown>
            </div>



        </div>
    );
}
